/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Error_RejectedInputs */

const vi_media_error_rejected = /** @type {(inputs: Media_Error_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy chủ không lưu được file (file hỏng hoặc ổ đĩa đầy). Thử lại hoặc chọn file khác.`)
};

/**

* @param {Media_Error_RejectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_error_rejected = /** @type {((inputs?: Media_Error_RejectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Error_RejectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_error_rejected(inputs)
});